// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__24T7E","inner":"Footer_inner__-6W1e"};